import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"logout\"><defs><style>#logout .cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px}</style></defs><path class=\"cls-1\" d=\"M96.25 243.56v37.1a23.09 23.09 0 0 0 23.09 23.09h161.32a23.09 23.09 0 0 0 23.09-23.09V119.34a23.09 23.09 0 0 0-23.09-23.09H119.34a23.09 23.09 0 0 0-23.09 23.09v37.1M242.98 200H96.25\" /><path class=\"cls-1\" d=\"M201.11 158.13L242.97 200l-41.86 41.87\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol